import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ConfigStatusBanner } from '@/features/settings/components/ConfigStatusBanner';
import { useSuspensionForceOut } from '@/features/professionals/hooks/useSuspensionForceOut';
import { useForcedOfflineNotice } from '@/features/professionals/hooks/useForcedOfflineNotice';

export function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useSuspensionForceOut();
  useForcedOfflineNotice();

  return (
    <div className="min-h-screen bg-brand-teal-50">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="lg:ml-64">
        <ConfigStatusBanner />
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
